<div [formGroup]="quickcallFieldsForm">
    <zsd-customfields [parentForm]="quickcallFieldsForm" [customFields]="customFields" [fromQuickCall]=true [id]="id">
    </zsd-customfields>
    <div *ngIf="quickCall.containCustomForm">
     <zsd-formio  [id]=id #formio [parentForm]='quickcallFieldsForm' [formSchema]='formSchema'></zsd-formio>
    </div>
</div>